import Vue from "vue";
import JsonEditor from "vue-json-edit";

Vue.use(JsonEditor);
